import { rowKeyOrHash } from "./row-key";
import type { SyncChange } from "./sync-state";

/**
 * Latest queued change per grid row id (ARD 9.6 row markers). A change targets
 * a `rowNumber`, so the row must still carry `_rowNumber` from the list answer.
 * A create that has not landed has `_rowNumber: null` and matches its own
 * `_sync.changeId` instead.
 */
export const changesByRow = (
  changes: SyncChange[],
  rows: any[],
  idField?: string
): Map<string, SyncChange> => {
  const byRow = new Map<string, SyncChange>();
  const idByRowNumber = new Map<number, string>();
  const idByChangeId = new Map<string, string>();

  rows.forEach((row) => {
    const id = rowKeyOrHash(row, idField);
    if (typeof row?._rowNumber === "number") {
      idByRowNumber.set(row._rowNumber, id);
    }
    const changeId = row?._sync?.changeId;
    if (typeof changeId === "string") idByChangeId.set(changeId, id);
  });

  const newer = (a: SyncChange, b: SyncChange) => {
    const at = Date.parse(a.createdAt);
    const bt = Date.parse(b.createdAt);
    if (Number.isFinite(at) && Number.isFinite(bt) && at !== bt) return at > bt;
    return true;
  };

  changes.forEach((change) => {
    const id =
      change.rowNumber != null
        ? idByRowNumber.get(change.rowNumber)
        : idByChangeId.get(change.id);
    if (!id) return;
    const current = byRow.get(id);
    if (!current || newer(change, current)) byRow.set(id, change);
  });

  return byRow;
};
